<div [formGroup]="form" class="weights-form">
  <fieldset class="weights-fieldset">
    <div *ngFor="let key of form.controls | keyvalue" class="weights-item">
      <ng-container *ngIf="key.key.startsWith(prefix)">
        <label class="weights-label">
          {{ labels[key.key] || key.key.replace(prefix, '') }}: 
          {{ form.get(key.key)?.value | number:'1.0-0' }}%
        </label>

        <input type="range"
               min="0"
               max="100"
               step="1"
               [formControlName]="key.key"
               class="weights-range"
               [style.background]="
                 'linear-gradient(to right, black ' + (form.get(key.key)?.value) + '%, #e5e7eb ' + (form.get(key.key)?.value) + '%, #d1d5db 100%)'
               ">
      </ng-container>
    </div>

    <div class="weights-total">
        <strong>Total: {{ (totalWeights) | number:'1.0-0' }}%</strong>
        <span *ngIf="!isTotalCorrect" class="weights-error">
            (Debe sumar 100%)
        </span>
    </div>
  </fieldset>
</div>
